<template>
  <div class="checkbox-wrapper d-inline-flex align-items-center" @click="toggle" role="button">
    <div class="checkbox" v-bind:class="{ selected: selected, disabled: disabled }">
      <div class="fa fa-check" v-show="selected"></div>
    </div>
    <div class="checkbox-label ml-2">
      <span>{{ label }}</span>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Boolean,
    label: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {};
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }

      this.$emit('input', !this.selected);
      this.$emit('change', !this.selected);
    }
  },
  computed: {
    selected() {
      return this.value;
    }
  }
};
</script>

<style scoped>
.checkbox {
  display: inline-block;
  width: 15px;
  min-width: 15px;
  height: 15px;
  min-height: 15px;
  padding: 0;
  padding-bottom: 0;
  color: white;
  font-size: 15px;
  line-height: 15px;
  border: 2px solid #097797;
  border-radius: 2px;
  cursor: pointer;
}
.selected {
  background-color: #097797;
}

.disabled {
  background-color: #ccc;
  border: 2px solid #ccc;
}

.fa {
  width: 12px;
  height: 12px;
  font-size: 12px;
  vertical-align: top;
}
</style>
